/**
 * Lesson registry - imports all lessons and registers them with the curriculum manager.
 */

import { registerLessons } from '../manager'
import { lesson1 } from './01-what-is-prediction-market'
import { lesson2 } from './02-understanding-prices'
import { lesson3 } from './03-order-book'
import { lesson4 } from './04-market-orders'
import { lesson5 } from './05-limit-orders'
import { lesson6 } from './06-price-discovery'
import { lesson8 } from './08-sandbox'

// All lessons in order
const allLessons = [
  lesson1,
  lesson2,
  lesson3,
  lesson4,
  lesson5,
  lesson6,
  // Note: Lesson 7 (Market Makers) is deferred per spec
  lesson8,
]

// Register all lessons when this module is imported
registerLessons(allLessons)

// Export for direct access if needed
export {
  lesson1,
  lesson2,
  lesson3,
  lesson4,
  lesson5,
  lesson6,
  lesson8,
  allLessons,
}

// Export scenarios for use in the app
export { orderBookScenario } from './03-order-book'
export { marketOrderScenario } from './04-market-orders'
export { limitOrderScenario } from './05-limit-orders'
export { priceDiscoveryScenario } from './06-price-discovery'
export {
  balancedScenario,
  bullishScenario,
  bearishScenario,
  volatileScenario,
  sandboxScenarios,
} from './08-sandbox'
